/* MAC STANDARD WORKBENCH — LIVE 3D PREVIEW (three.js, lazy-loaded)
   Listens for "wb:change" from workbench-configurator.js. Dimensions in mm. */
(function () {
  "use strict";
  var V = "0.160.0", CDN = "https://cdn.jsdelivr.net/npm/three@" + V;
  var COLS = { "red": 0xdc2626, "green": 0x16a34a, "blue": 0x2563eb, "grey": 0x6b7280, "black": 0x1b1d22, "raw-no-paint": 0xd4d4d8 };
  var DEF = { length: 1500, depth: 800, top: 8, castors: false, colour: "Grey" };
  var box = document.querySelector("[data-wb3d]");
  if (!box) return;
  var state = Object.assign({}, DEF), api = null, started = false;
  function merge(s) { s = s || {}; return { length: s.length || DEF.length, depth: s.depth || DEF.depth, top: s.top || DEF.top, castors: s.castors === true, colour: s.colour || DEF.colour }; }
  document.addEventListener("wb:change", function (e) { try { state = merge(e.detail); if (api) api.update(state); } catch (err) { if (window.console) console.warn("3D update failed", err); } });
  if (window.__wbState) state = merge(window.__wbState);

  /* Shopify's asset minifier rewrites import(), so load via a module script tag */
  function loadModules(base) {
    base = base || CDN;
    return new Promise(function (res, rej) {
      window.__wb3dLoaded = function (T, O) { res([T, { OrbitControls: O }]); };
      var sc = document.createElement("script"); sc.type = "module";
      sc.textContent = 'import * as T from "' + base + '/+esm"; import { OrbitControls as O } from "' + base + '/examples/jsm/controls/OrbitControls.js/+esm"; window.__wb3dLoaded(T, O);';
      sc.onerror = rej; setTimeout(function () { rej(new Error("timeout")); }, 20000);
      document.head.appendChild(sc);
    });
  }
  function fail(err) {
    box.classList.remove("is-loading"); box.classList.add("is-failed");
    var st = box.querySelector(".wb3d__status"); if (st) st.textContent = "3D preview isn't available in this browser. Your options and price still work.";
    box.classList.add("wb3d--msg"); var cs = document.createElement("style"); cs.textContent = ".wb3d.wb3d--msg .wb3d__status::after{content:none}.wb3d.wb3d--msg .wb3d__status{width:80%;text-align:center}"; document.head.appendChild(cs); if (window.console) console.warn("3D preview unavailable", err && (err.stack || err));
  }
  function hasWebGL() { try { var c = document.createElement("canvas"); return !!(window.WebGLRenderingContext && (c.getContext("webgl2") || c.getContext("webgl"))); } catch (e) { return false; } }
  function start() {
    if (started) return; started = true;
    box.classList.add("is-loading");
    if (!hasWebGL()) return fail(new Error("WebGL not available"));
    loadModules().catch(function () { return loadModules("https://fastly.jsdelivr.net/npm/three@" + V); })
      .then(function (m) { try { api = build(m[0], m[1].OrbitControls); api.update(state); box.classList.remove("is-loading"); box.classList.add("is-ready"); } catch (e) { api = null; fail(e); } })
      .catch(fail);
  }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: "200px" });
    io.observe(box);
  } else start();

  function build(THREE, OrbitControls) {
    var holder = box.querySelector(".wb3d__canvas");
    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: "low-power" });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    holder.appendChild(renderer.domElement);
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(35, 1, 10, 30000);
    var controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true; controls.dampingFactor = 0.08; controls.enablePan = false;
    controls.maxPolarAngle = Math.PI * 0.49;
    scene.add(new THREE.HemisphereLight(0xffffff, 0x8a8f99, 1.6));
    var sun = new THREE.DirectionalLight(0xffffff, 2.2);
    sun.position.set(1500, 3000, 2000); sun.castShadow = true;
    sun.shadow.mapSize.set(1024, 1024); sun.shadow.radius = 6;
    var sc = sun.shadow.camera; sc.left = -2000; sc.right = 2000; sc.top = 2000; sc.bottom = -2000; sc.near = 100; sc.far = 8000;
    scene.add(sun);
    var fill = new THREE.DirectionalLight(0xffffff, 0.6); fill.position.set(-2000, 1200, -1500); scene.add(fill);
    var ground = new THREE.Mesh(new THREE.PlaneGeometry(12000, 12000), new THREE.ShadowMaterial({ opacity: 0.22 }));
    ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; scene.add(ground);

    var steel = new THREE.MeshStandardMaterial({ color: 0xb4b9c0, metalness: 0.85, roughness: 0.38 });
    var paint = new THREE.MeshStandardMaterial({ color: 0x6b7280, metalness: 0.15, roughness: 0.55 });
    var rubber = new THREE.MeshStandardMaterial({ color: 0x222222, roughness: 0.9 });
    var gold = new THREE.MeshStandardMaterial({ color: 0xd4a017, metalness: 0.8, roughness: 0.3 });
    var zinc = new THREE.MeshStandardMaterial({ color: 0xc9cdd2, metalness: 0.8, roughness: 0.35 });
    var bench = new THREE.Group(); scene.add(bench);

    function add(g, mat, x, y, z, w, h, d) { var m = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), mat); m.position.set(x, y, z); m.castShadow = true; m.receiveShadow = true; g.add(m); return m; }
    function clear() { while (bench.children.length) { var c = bench.children.pop(); c.traverse(function (o) { if (o.geometry) o.geometry.dispose(); }); } }

    function make(s) {
      clear();
      var L = s.length, D = s.depth, H = 900, T = 6 + s.top * 1.6; /* exaggerated: 6/8/10 -> 15.6/18.8/22mm drawn */
      var F = 4, LEG = 60, inset = 25, cast = s.castors ? 127 : 0;
      var topY = H - T, legBot = cast, legH = topY - legBot;
      add(bench, steel, 0, H - T / 2, 0, L, T, D);
      /* apron: 4mm folded C-section, 100mm deep, inward lip */
      var AH = 100, lip = 30, ay = topY - AH / 2;
      var ax = L / 2 - inset - F / 2, az = D / 2 - inset - F / 2;
      [1, -1].forEach(function (sg) {
        add(bench, paint, 0, ay, sg * az, L - 2 * inset, AH, F);
        add(bench, paint, 0, topY - AH + F / 2, sg * (az - lip / 2), L - 2 * inset, F, lip);
        add(bench, paint, sg * ax, ay, 0, F, AH, D - 2 * inset);
        add(bench, paint, sg * (ax - lip / 2), topY - AH + F / 2, 0, lip, F, D - 2 * inset);
      });
      /* legs: 4mm laser cut + folded L-angle, corner to outside */
      var lx = L / 2 - inset - LEG / 2, lz = D / 2 - inset - LEG / 2;
      var legs = [[1, 1], [1, -1], [-1, 1], [-1, -1]];
      legs.forEach(function (p) {
        var ly = legBot + legH / 2;
        add(bench, paint, p[0] * lx, ly, p[1] * (lz + LEG / 2 - F / 2), LEG, legH, F); /* flange on outer long face */
        add(bench, paint, p[0] * (lx + LEG / 2 - F / 2), ly, p[1] * (lz - F / 2), F, legH, LEG - F); /* flange on outer end face */
        add(bench, paint, p[0] * lx, legBot + F / 2, p[1] * lz, LEG + 20, F, LEG + 20); /* foot plate */
      });
      /* bottom bracing: folded angle rails forming an inward ledge */
      var BY = legBot + 160, BH = 60, ledge = 45;
      var bx = lx - LEG / 2 - F / 2 + LEG, bz = lz - LEG / 2 - F / 2 + LEG;
      var runL = 2 * lx - LEG, runD = 2 * lz - LEG;
      [1, -1].forEach(function (sg) {
        var zf = sg * (lz + LEG / 2 - F / 2), xf = sg * (lx + LEG / 2 - F / 2);
        add(bench, paint, 0, BY, zf, runL, BH, F);
        add(bench, paint, 0, BY + BH / 2 - F / 2, zf - sg * ledge / 2, runL, F, ledge);
        add(bench, paint, xf, BY, 0, F, BH, runD);
        add(bench, paint, xf - sg * ledge / 2, BY + BH / 2 - F / 2, 0, ledge, F, runD);
      });
      /* gold M10 hex bolt heads: 2 per joint face, outer faces, apron + bracing to legs */
      try { (function () {
        var bg = new THREE.CylinderGeometry(8.5, 8.5, 6.5, 6), pts = [], ox = L / 2 - inset + 3.25, oz = D / 2 - inset + 3.25;
        legs.forEach(function (p) {
          [[ay - 25, ay + 25], [BY - 15, BY + 15]].forEach(function (ys) {
            ys.forEach(function (y) { pts.push([p[0] * lx, y, p[1] * oz, 1]); pts.push([p[0] * ox, y, p[1] * lz, 0]); });
          });
        });
        function pose(o, q) { o.position.set(q[0], q[1], q[2]); o.rotation.set(q[3] ? Math.PI / 2 : 0, 0, q[3] ? 0 : Math.PI / 2); o.updateMatrix(); }
        var inst = false;
        if (THREE.InstancedMesh) try {
          var im = new THREE.InstancedMesh(bg, gold, pts.length), o = new THREE.Object3D();
          pts.forEach(function (q, i) { pose(o, q); im.setMatrixAt(i, o.matrix); });
          im.instanceMatrix.needsUpdate = true; im.castShadow = true; bench.add(im); inst = true;
        } catch (e) { inst = false; }
        if (!inst) pts.forEach(function (q) { var m = new THREE.Mesh(bg, gold); pose(m, q); m.castShadow = true; bench.add(m); });
      })(); } catch (e) { if (window.console) console.warn("bolts skipped", e); }
      /* castors: 127mm overall */
      if (s.castors) legs.forEach(function (p) {
        var x = p[0] * lx, z = p[1] * lz, g = new THREE.Group(); g.position.set(x, 0, z);
        add(g, zinc, 0, 127 - 4, 0, 70, 8, 70);
        add(g, zinc, 0, 127 - 14, 0, 40, 12, 40);
        add(g, zinc, 14, 70, 0, 4, 80, 34); add(g, zinc, -14, 70, 0, 4, 80, 34);
        var w = new THREE.Mesh(new THREE.CylinderGeometry(50, 50, 24, 28), rubber);
        w.rotation.z = Math.PI / 2; w.position.y = 50; w.castShadow = true; g.add(w);
        var hub = new THREE.Mesh(new THREE.CylinderGeometry(20, 20, 30, 16), zinc);
        hub.rotation.z = Math.PI / 2; hub.position.y = 50; g.add(hub);
        bench.add(g);
      });
      var key = String(s.colour).toLowerCase().replace(/\s+/g, "-");
      paint.color.setHex(COLS[key] != null ? COLS[key] : 0x6b7280);
    }
    var lastSize = "";
    function fit(s) {
      var r = 0.5 * Math.sqrt(s.length * s.length + s.depth * s.depth + 900 * 900);
      var w = holder.clientWidth || 400, h = holder.clientHeight || 300, a = w / h;
      var fov = camera.fov * Math.PI / 180, hf = 2 * Math.atan(Math.tan(fov / 2) * a);
      var dist = r / Math.sin(Math.min(fov, hf) / 2) * 1.02;
      controls.target.set(0, 430, 0);
      var dir = new THREE.Vector3(0.75, 0.55, 1).normalize();
      camera.position.copy(dir.multiplyScalar(dist)).add(controls.target);
      controls.minDistance = dist * 0.2; controls.maxDistance = dist * 2.2;
      controls.update();
    }
    function resize() {
      var w = holder.clientWidth, h = holder.clientHeight; if (!w || !h) return;
      renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix();
      wake();
    }
    var running = false, idle = 0;
    function loop() { if (controls.update() ) idle = 0; renderer.render(scene, camera); if (++idle < 90) requestAnimationFrame(loop); else running = false; }
    function wake() { idle = 0; if (!running) { running = true; requestAnimationFrame(loop); } }
    controls.addEventListener("change", wake);
    renderer.domElement.addEventListener("pointerdown", wake);
    if ("ResizeObserver" in window) new ResizeObserver(resize).observe(holder); else window.addEventListener("resize", resize);
    resize();
    return { update: function (s) { try { make(s); } catch (e) { if (window.console) console.warn("3D update failed", e); return; } var k = s.length + "x" + s.depth; if (k !== lastSize) { lastSize = k; fit(s); } box.setAttribute("data-config", [s.length, s.depth, s.top, s.castors ? "C" : "F", s.colour].join("-")); wake(); } };
  }
})();


